import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M11.7801 3.62488L5.58349 5.71752C5.02519 5.90606 5.0241 6.69533 5.58189 6.8854L11.8149 9.00939C11.9439 9.05334 12.0837 9.05334 12.2127 9.00939L18.4457 6.8854C19.0035 6.69533 19.0024 5.90606 18.4441 5.71752L12.2475 3.62488C12.0917 3.57296 11.9359 3.57296 11.7801 3.62488ZM3.44602 18.0346L10.342 20.3797C10.7419 20.5157 11.1571 20.2184 11.1571 19.7959V11.0518C11.1571 10.7872 10.9884 10.5522 10.7377 10.4676L3.74059 8.10576C3.34088 7.97084 2.92676 8.26813 2.92676 8.69V17.3336C2.92676 17.6452 3.13446 17.9308 3.44602 18.0346ZM12.8701 11.0513C12.8701 10.787 13.0386 10.5521 13.289 10.4673L20.2601 8.10681C20.6599 7.97143 21.0745 8.26875 21.0745 8.69087V17.3336C21.0745 17.6452 20.8928 17.9308 20.5812 18.0346L13.6853 20.3797C13.2853 20.5157 12.8701 20.2184 12.8701 19.7959V11.0513Z"
    fillRule="evenodd"
  />,
  'BoxIcon',
)
